import {
  ShoppingCartSimpleIcon as PhosphorShoppingCartIcon,
  type IconProps,
} from "@phosphor-icons/react";

export function ShoppingCartIcon(props: IconProps): React.ReactElement {
  return <PhosphorShoppingCartIcon size={24} weight="regular" {...props} />;
}
